<ng-container *ngIf="data$ | async as data">
  <div class="change-password-container">
    <div class="change-password-heading">
      <p>{{ 'changePasswordForm.heading' | cxTranslate }}</p>
    </div>

    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
      <div class="change-password row">
        <div class="change-password-form col-lg-6 col-md-7 col-sm-12">
          <mat-form-field appearance="outline" class="w-100 mt-3" [hideRequiredMarker]="true">
            <mat-label>{{ 'changePasswordForm.oldLabel' | cxTranslate }}</mat-label>
            <input
              matInput
              [type]="hideOldPassword ? 'password' : 'text'"
              [placeholder]="'changePasswordForm.oldLabel' | cxTranslate"
              formControlName="oldPassword"
            />
            <span matSuffix>
              <mat-icon matSuffix="" class="material-icons-outlined" (click)="hideOldPassword = !hideOldPassword">
                {{ hideOldPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </span>
            <mat-error *ngIf="changePasswordForm.hasError('required', 'oldPassword')">
              {{ 'changePasswordForm.error.oldRequired' | cxTranslate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100 mt-3" [hideRequiredMarker]="true">
            <mat-label>{{ 'changePasswordForm.newLabel' | cxTranslate }}</mat-label>
            <input
              matInput
              [type]="hideNewPassword ? 'password' : 'text'"
              [placeholder]="'changePasswordForm.newLabel' | cxTranslate"
              formControlName="newPassword"
            />
            <span matSuffix>
              <!-- <mat-icon matSuffix="" class="material-icons-outlined" (click)="hide = !hide">
                {{ hide ? 'visibility_off' : 'visibility' }}
              </mat-icon> -->
              <mat-icon matSuffix="" class="material-icons-outlined" (click)="hideNewPassword = !hideNewPassword">
                {{ hideNewPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </span>
            <mat-error *ngIf="changePasswordForm.hasError('required', 'newPassword')">
              {{ 'changePasswordForm.error.newRequired' | cxTranslate }}
            </mat-error>
            <mat-error *ngIf="changePasswordForm.hasError('pattern', 'newPassword')">
              {{ 'changePasswordForm.error.passComplexity' | cxTranslate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100 mt-3" [hideRequiredMarker]="true">
            <mat-label>{{ 'changePasswordForm.confirmLabel' | cxTranslate }}</mat-label>
            <input
              matInput
              [type]="hideConfirmPassword ? 'password' : 'text'"
              [placeholder]="'changePasswordForm.confirmLabel' | cxTranslate"
              formControlName="confirmPassword"
            />
            <span matSuffix>
              <mat-icon
                matSuffix=""
                class="material-icons-outlined"
                (click)="hideConfirmPassword = !hideConfirmPassword"
              >
                {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </span>
            <mat-error *ngIf="changePasswordForm.hasError('required', 'confirmPassword')">
              {{ 'changePasswordForm.error.confirmRequired' | cxTranslate }}
            </mat-error>
            <mat-error *ngIf="changePasswordForm.hasError('mustMatch', 'confirmPassword')">
              {{ 'changePasswordForm.error.passMatch' | cxTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="change-password-guide col-lg-6 col-md-5 col-sm-12">
          <h5>{{ 'changePasswordForm.guidelines.heading' | cxTranslate }}</h5>
          <div class="password-guidelines" [innerHTML]="'changePasswordForm.guidelines.guide' | cxTranslate"></div>
        </div>
      </div>
      <div class="change-password-button">
        <button type="reset" (click)="triggerCancel()" class="btn-outline-primary">
          {{ 'changePasswordForm.buttons.btnCancel' | cxTranslate | uppercase }}
        </button>
        <button [disabled]="disablingButton(changePasswordForm)" [class.disabled]="buttonNoUpdate" class="btn-primary">
          {{ 'changePasswordForm.buttons.btnSave' | cxTranslate | uppercase }}
        </button>
      </div>
    </form>
  </div>
</ng-container>
